var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.LoadingFlag}},[_c('div',{staticClass:"text-center"},[(_vm.LoadingText != '')?_c('p',[_vm._v(_vm._s(_vm.LoadingText))]):_c('p',[_vm._v("Please wait, your request is processing...")]),_c('p'),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }